import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const CompleteSignup = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [message, setMessage] = useState("Completing your signup...");
  const [error, setError] = useState("");

  useEffect(() => {
    const completeSignup = async () => {
      const email = (searchParams.get("email") || localStorage.getItem("signup_email") || "")
        .trim()
        .toLowerCase();

      if (!email) {
        setError("Missing signup email. Please log in or try signing up again.");
        setMessage("");
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/complete-signup`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          setError(data.error || "Could not complete signup. Please try again.");
          setMessage("");
          return;
        }

        localStorage.removeItem("signup_email");

        setMessage("Email verified and signup completed. Redirecting to login...");
        setError("");

        setTimeout(() => {
          navigate("/login");
        }, 1500);
      } catch (err) {
        console.error("Complete signup error:", err);
        setError("Unexpected error completing signup. Please try again.");
        setMessage("");
      }
    };

    completeSignup();
  }, [navigate, searchParams]);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{error ? "Signup Not Completed" : "Completing Signup"}</h2>

      {message && <p style={styles.text}>{message}</p>}
      {error && (
        <>
          <p style={styles.error}>{error}</p>
          <button style={styles.button} onClick={() => navigate("/check-your-email")}>
            Back to Verification Page
          </button>
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "30px",
    textAlign: "center",
  },
  title: {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  text: {
    fontSize: "16px",
    color: "#444",
  },
  error: {
    color: "#b00020",
    marginTop: "15px",
  },
  button: {
    marginTop: "16px",
    padding: "12px 20px",
    fontSize: "15px",
    backgroundColor: "#1E2A78",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
};

export default CompleteSignup;
